import { render, staticRenderFns } from "./CustomInputsModalDialog.vue?vue&type=template&id=f5b0a8f6&"
import script from "./CustomInputsModalDialog.vue?vue&type=script&lang=js&"
export * from "./CustomInputsModalDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports